export const newChildSchema = ({ owner, name='', birthdate='', picture='a', ...props }) => {
  return { owner, name, birthdate, picture, created: Date(), ...props }

}

export const updateChildSchema = () => {

}